import { FormikHelpers } from "formik";
import { FC, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader } from "../../../components/loader/SpinnerLogo";
import useFetch from "../../../hooks/useFetch";
import useHandleErrors from "../../../hooks/useHandleErrors";
import { UserService } from "../../../services/user/userService";
import { User } from "../../../type/entities/user-type";
import UserForm from "../UserForm";
import UserEditLayout from "./UserEditLayout";

const UserEdit: FC = () => {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new UserService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getUserById(id as string);
        return response.getResponseData() as User;
    }, [id]));

    const handleSubmit = async (values: any, helpers: FormikHelpers<any>) => {
        setIsLoading(true);
        try {
            if (values.password !== "" && values.passwordConfirm !== "") {
                const result = await service.changePassword(id, values.password, values.passwordConfirm);

                if (result.getResponseData().success) {
                    toast.success("Contraseña cambiada correctamente");
                } else {
                    toast.error("Error al cambiar la contraseña");
                }
            }

            const response = (await service.editUser(values)).getResponseData();

            if (response.success) {
                navigate(-1);
                toast.success("Usuario editado correctamente");
                if (data?.commercialNetwork?.id !== values.commercialNetworkId) {
                    toast.info("Para que el cambio de red comercial tenga efecto, el usuario debe cerrar sesión y volver a iniciarla");
                }
            } else {
                if (response.data?.errors) {
                    const fieldErrors: Record<string, string> = {};
                    response.data.errors.forEach((error: any) => {
                        if (error.property) {
                            fieldErrors[error.property] = error.message;
                        } else {
                            toast.error(error.message);
                        }
                    });
                    helpers.setErrors(fieldErrors);
                } else {
                    handleErrors(response);
                }
            }
        } catch (error: any) {
            toast.error("Error al editar el usuario");
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <UserEditLayout>
            {(data !== null && data !== undefined) && <UserForm data={data} submit={handleSubmit} isLoading={isLoading} profileImg={data.profileImg} />}
        </UserEditLayout>
    );
};

export default UserEdit;